export const PERMS = {
    READ: 'report_driver_results.read',
    UPDATE: 'report_driver_results.update',
    DELETE: 'report_driver_results.delete',
    CREATE: 'report_driver_results.create',
    EXPORT: 'report_driver_results.export',
}
